import { useMutation, useQueryClient } from '@tanstack/react-query'

import { apiPostQuizSubmit } from '@/apis/quiz/postQuizSubmit'
import type { QuizSubmitRequest } from '@/types/quiz'

import { COIN_KEYS } from '../keys/coins'
import { QUIZ_KEYS } from '../keys/quiz'

export const usePostQuizSubmit = (quizId: number) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (body: QuizSubmitRequest) => apiPostQuizSubmit(quizId, body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUIZ_KEYS.LIST] })
      queryClient.invalidateQueries({ queryKey: [COIN_KEYS.BALANCE] })
    },
  })
}
